import { useEffect } from "react";

export default function Ascii() {
  useEffect(() => {
    console.log(`
       ░▒▓█▓▒░░▒▓██████▓▒░░▒▓█▓▒░░▒▓█▓▒░▒▓████████▓▒░      ░▒▓██████████████▓▒░░▒▓█▓▒░▒▓█▓▒░      ░▒▓█▓▒░      ░▒▓████████▓▒░▒▓███████▓▒░  
       ░▒▓█▓▒░▒▓█▓▒░░▒▓█▓▒░▒▓█▓▒░░▒▓█▓▒░▒▓█▓▒░             ░▒▓█▓▒░░▒▓█▓▒░░▒▓█▓▒░▒▓█▓▒░▒▓█▓▒░      ░▒▓█▓▒░      ░▒▓█▓▒░      ░▒▓█▓▒░░▒▓█▓▒░ 
       ░▒▓█▓▒░▒▓█▓▒░░▒▓█▓▒░▒▓█▓▒░░▒▓█▓▒░▒▓█▓▒░             ░▒▓█▓▒░░▒▓█▓▒░░▒▓█▓▒░▒▓█▓▒░▒▓█▓▒░      ░▒▓█▓▒░      ░▒▓█▓▒░      ░▒▓█▓▒░░▒▓█▓▒░ 
       ░▒▓█▓▒░▒▓████████▓▒░▒▓███████▓▒░░▒▓██████▓▒░        ░▒▓█▓▒░░▒▓█▓▒░░▒▓█▓▒░▒▓█▓▒░▒▓█▓▒░      ░▒▓█▓▒░      ░▒▓██████▓▒░ ░▒▓███████▓▒░  
░▒▓█▓▒░░▒▓█▓▒░▒▓█▓▒░░▒▓█▓▒░▒▓█▓▒░░▒▓█▓▒░▒▓█▓▒░             ░▒▓█▓▒░░▒▓█▓▒░░▒▓█▓▒░▒▓█▓▒░▒▓█▓▒░      ░▒▓█▓▒░      ░▒▓█▓▒░      ░▒▓█▓▒░░▒▓█▓▒░ 
░▒▓█▓▒░░▒▓█▓▒░▒▓█▓▒░░▒▓█▓▒░▒▓█▓▒░░▒▓█▓▒░▒▓█▓▒░             ░▒▓█▓▒░░▒▓█▓▒░░▒▓█▓▒░▒▓█▓▒░▒▓█▓▒░      ░▒▓█▓▒░      ░▒▓█▓▒░      ░▒▓█▓▒░░▒▓█▓▒░ 
 ░▒▓██████▓▒░░▒▓█▓▒░░▒▓█▓▒░▒▓█▓▒░░▒▓█▓▒░▒▓████████▓▒░      ░▒▓█▓▒░░▒▓█▓▒░░▒▓█▓▒░▒▓█▓▒░▒▓████████▓▒░▒▓████████▓▒░▒▓████████▓▒░▒▓█▓▒░░▒▓█▓▒░ 
                                                                                                                                           
                                                                                                                                           
                                                                                                                                      ░▒▓██████████████████████████████████████████████████████████████████████████████████████████████████████████████████████████████████████▓▒░
  
  System Log: J∆KE MILLER v1.0
  
  [*] - Launch Date:            04.13.2025
  [*] - Version....:            v1.0
  [*] - Frontend...:            SASS / PUG / GSAP / React.js / Lottie 
  [*] - API........:            Web3Forms
  
  [*] - Notes......:            The initial version of this project, V1, was a fast, functional build 
                                developed within my Pug/SASS/JavaScript environment. I had established 
                                much of the core functionality, but the project was temporarily shelved 
                                after a career shift led me into a new role and responsibilities. 
                                Once things settled, I revisited the project with a fresh perspective 
                                and refined vision. This time, I chose to rebuild the site in React to 
                                better support scalability and to move to a more component-based 
                                architecture with the aim to control the entire site through one 
                                json file.
  
                                In that spirit, I broke my goals down into components—just as I would 
                                the UI itself. While V1 doesn’t represent a full MVP, it served as a 
                                thoughtful starting point for mapping out animations, layout patterns, 
                                and cross-browser functionality. (Yes, Firefox and Safari still keep 
                                things interesting.) For design inspiration, I returned to the 
                                fundamentals—revisiting design texts from college and drawing from the 
                                structured beauty of Constructivism, Bauhaus, and the grid systems of 
                                Vilmos Husár’s De Stijl work. Layered with my background in mathematics, 
                                I explored symmetry, number patterns, and the golden ratio to inform 
                                structure and visual balance throughout this build.

  
  ░▒▓██████████████████████████████████████████████████████████████████████████████████████████████████████████████████████████████████████▓▒░`);
  }, []);
}
